"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invested = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var investment_1 = require("../../model/investment");
var service_1 = require("../../../library/base/service");
var Invested = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Invested, _super);
    function Invested() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '已投资客户初始化接口';
        _this.code = '101011';
        _this.desc = '已投资客户初始化接口';
        _this.requestParams = new investment_1.InvestedRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Invested;
}(service_1.BaseService));
exports.Invested = Invested;
//# sourceMappingURL=invested.js.map